"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.VectorSourceEvent = void 0;

var _Collection = _interopRequireDefault(require("../Collection.js"));

var _CollectionEventType = _interopRequireDefault(require("../CollectionEventType.js"));

var _Event = _interopRequireDefault(require("../events/Event.js"));

var _EventType = _interopRequireDefault(require("../events/EventType.js"));

var _ObjectEventType = _interopRequireDefault(require("../ObjectEventType.js"));

var _RBush = _interopRequireDefault(require("../structs/RBush.js"));

var _Source = _interopRequireDefault(require("./Source.js"));

var _State = _interopRequireDefault(require("./State.js"));

var _VectorEventType = _interopRequireDefault(require("./VectorEventType.js"));

var _functions = require("../functions.js");

var _loadingstrategy = require("../loadingstrategy.js");

var _asserts = require("../asserts.js");

var _extent = require("../extent.js");

var _array = require("../array.js");

var _util = require("../util.js");

var _obj = require("../obj.js");

var _events = require("../events.js");

var _featureloader = require("../featureloader.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @module ol/source/Vector
 */
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

/**
 * A function that takes an {@link module:ol/extent~Extent} and a resolution as arguments, and
 * returns an array of {@link module:ol/extent~Extent} with the extents to load. Usually this
 * is one of the standard {@link module:ol/loadingstrategy} strategies.
 *
 * @typedef {function(import("../extent.js").Extent, number, import("../proj/Projection.js").default): Array<import("../extent.js").Extent>} LoadingStrategy
 * @api
 */

/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Vector~VectorSource} instances are instances of this
 * type.
 * @template {import("../geom/Geometry.js").default} [Geometry=import("../geom/Geometry.js").default]
 */
var VectorSourceEvent =
/** @class */
function (_super) {
  __extends(VectorSourceEvent, _super);
  /**
   * @param {string} type Type.
   * @param {import("../Feature.js").default<Geometry>} [opt_feature] Feature.
   * @param {Array<import("../Feature.js").default<Geometry>>} [opt_features] Features.
   */


  function VectorSourceEvent(type, opt_feature, opt_features) {
    var _this = _super.call(this, type) || this;
    /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {import("../Feature.js").default<Geometry>|undefined}
     * @api
     */


    _this.feature = opt_feature;
    /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<import("../Feature.js").default<Geometry>>|undefined}
     * @api
     */

    _this.features = opt_features;
    return _this;
  }

  return VectorSourceEvent;
}(_Event["default"]);

exports.VectorSourceEvent = VectorSourceEvent;

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */

/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<import("../Feature.js").default>|Collection<import("../Feature.js").default>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import {Vector} from 'ol/source';
 * import {GeoJSON} from 'ol/format';
 * import {bbox} from 'ol/loadingstrategy';
 *
 * var vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      var proj = projection.getCode();
 *      var url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      var xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      var onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          var features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */

/**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../geom/Geometry.js").default} [Geometry=import("../geom/Geometry.js").default]
 */
var VectorSource =
/** @class */
function (_super) {
  __extends(VectorSource, _super);
  /**
   * @param {Options} [opt_options] Vector source options.
   */


  function VectorSource(opt_options) {
    var _this = this;

    var options = opt_options || {};
    _this = _super.call(this, {
      attributions: options.attributions,
      interpolate: true,
      projection: undefined,
      state: _State["default"].READY,
      wrapX: options.wrapX !== undefined ? options.wrapX : true
    }) || this;
    /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey>}
     */

    _this.on;
    /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey>}
     */

    _this.once;
    /***
     * @type {VectorSourceOnSignature<void>}
     */

    _this.un;
    /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader}
     */

    _this.loader_ = _functions.VOID;
    /**
     * @private
     * @type {import("../format/Feature.js").default|undefined}
     */

    _this.format_ = options.format;
    /**
     * @private
     * @type {boolean}
     */

    _this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
    /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */

    _this.url_ = options.url;

    if (options.loader !== undefined) {
      _this.loader_ = options.loader;
    } else if (_this.url_ !== undefined) {
      (0, _asserts.assert)(_this.format_, 7); // `format` must be set when `url` is set
      // create a XHR feature loader for "url" and "format"

      _this.loader_ = (0, _featureloader.xhr)(_this.url_,
      /** @type {import("../format/Feature.js").default} */
      _this.format_);
    }
    /**
     * @private
     * @type {LoadingStrategy}
     */


    _this.strategy_ = options.strategy !== undefined ? options.strategy : _loadingstrategy.all;
    var useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
    /**
     * @private
     * @type {RBush<import("../Feature.js").default<Geometry>>}
     */

    _this.featuresRtree_ = useSpatialIndex ? new _RBush["default"]() : null;
    /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */

    _this.loadedExtentsRtree_ = new _RBush["default"]();
    /**
     * @type {number}
     * @private
     */

    _this.loadingExtentsCount_ = 0;
    /**
     * @private
     * @type {!Object<string, import("../Feature.js").default<Geometry>>}
     */

    _this.nullGeometryFeatures_ = {};
    /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import("../Feature.js").default<Geometry>>}
     */

    _this.idIndex_ = {};
    /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, import("../Feature.js").default<Geometry>>}
     */

    _this.uidIndex_ = {};
    /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */

    _this.featureChangeKeys_ = {};
    /**
     * @private
     * @type {Collection<import("../Feature.js").default<Geometry>>|null}
     */

    _this.featuresCollection_ = null;
    var collection, features;

    if (Array.isArray(options.features)) {
      features =
      /** @type {Array<import("../Feature.js").default<Geometry>>} */
      options.features;
    } else if (options.features) {
      collection =
      /** @type {Collection<import("../Feature.js").default<Geometry>>} */
      options.features;
      features = collection.getArray();
    }

    if (!useSpatialIndex && collection === undefined) {
      collection = new _Collection["default"](features);
    }

    if (features !== undefined) {
      _this.addFeaturesInternal(features);
    }

    if (collection !== undefined) {
      _this.bindFeaturesCollection_(collection);
    }

    return _this;
  }
  /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if an {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {import("../Feature.js").default<Geometry>} feature Feature to add.
   * @api
   */


  VectorSource.prototype.addFeature = function (feature) {
    this.addFeatureInternal(feature);
    this.changed();
  };
  /**
   * Add a feature without firing a `change` event.
   * @param {import("../Feature.js").default<Geometry>} feature Feature.
   * @protected
   */


  VectorSource.prototype.addFeatureInternal = function (feature) {
    var featureKey = (0, _util.getUid)(feature);

    if (!this.addToIndex_(featureKey, feature)) {
      if (this.featuresCollection_) {
        this.featuresCollection_.remove(feature);
      }

      return;
    }

    this.setupChangeEvents_(featureKey, feature);
    var geometry = feature.getGeometry();

    if (geometry) {
      var extent = geometry.getExtent();

      if (this.featuresRtree_) {
        this.featuresRtree_.insert(extent, feature);
      }
    } else {
      this.nullGeometryFeatures_[featureKey] = feature;
    }

    this.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].ADDFEATURE, feature));
  };
  /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {import("../Feature.js").default<Geometry>} feature The feature.
   * @private
   */


  VectorSource.prototype.setupChangeEvents_ = function (featureKey, feature) {
    this.featureChangeKeys_[featureKey] = [(0, _events.listen)(feature, _EventType["default"].CHANGE, this.handleFeatureChange_, this), (0, _events.listen)(feature, _ObjectEventType["default"].PROPERTYCHANGE, this.handleFeatureChange_, this)];
  };
  /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {import("../Feature.js").default<Geometry>} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */


  VectorSource.prototype.addToIndex_ = function (featureKey, feature) {
    var valid = true;
    var id = feature.getId();

    if (id !== undefined) {
      if (!(id.toString() in this.idIndex_)) {
        this.idIndex_[id.toString()] = feature;
      } else {
        valid = false;
      }
    }

    if (valid) {
      (0, _asserts.assert)(!(featureKey in this.uidIndex_), 30); // The passed `feature` was already added to the source

      this.uidIndex_[featureKey] = feature;
    }

    return valid;
  };
  /**
   * Add a batch of features to the source.
   * @param {Array<import("../Feature.js").default<Geometry>>} features Features to add.
   * @api
   */


  VectorSource.prototype.addFeatures = function (features) {
    this.addFeaturesInternal(features);
    this.changed();
  };
  /**
   * Add features without firing a `change` event.
   * @param {Array<import("../Feature.js").default<Geometry>>} features Features.
   * @protected
   */


  VectorSource.prototype.addFeaturesInternal = function (features) {
    var extents = [];
    var newFeatures = [];
    var geometryFeatures = [];

    for (var i = 0, length_1 = features.length; i < length_1; i++) {
      var feature = features[i];
      var featureKey = (0, _util.getUid)(feature);

      if (this.addToIndex_(featureKey, feature)) {
        newFeatures.push(feature);
      }
    }

    for (var i = 0, length_2 = newFeatures.length; i < length_2; i++) {
      var feature = newFeatures[i];
      var featureKey = (0, _util.getUid)(feature);
      this.setupChangeEvents_(featureKey, feature);
      var geometry = feature.getGeometry();

      if (geometry) {
        var extent = geometry.getExtent();
        extents.push(extent);
        geometryFeatures.push(feature);
      } else {
        this.nullGeometryFeatures_[featureKey] = feature;
      }
    }

    if (this.featuresRtree_) {
      this.featuresRtree_.load(extents, geometryFeatures);
    }

    if (this.hasListener(_VectorEventType["default"].ADDFEATURE)) {
      for (var i = 0, length_3 = newFeatures.length; i < length_3; i++) {
        this.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].ADDFEATURE, newFeatures[i]));
      }
    }
  };
  /**
   * @param {!Collection<import("../Feature.js").default<Geometry>>} collection Collection.
   * @private
   */


  VectorSource.prototype.bindFeaturesCollection_ = function (collection) {
    var modifyingCollection = false;
    this.addEventListener(_VectorEventType["default"].ADDFEATURE,
    /**
     * @param {VectorSourceEvent<Geometry>} evt The vector source event
     */
    function (evt) {
      if (!modifyingCollection) {
        modifyingCollection = true;
        collection.push(evt.feature);
        modifyingCollection = false;
      }
    });
    this.addEventListener(_VectorEventType["default"].REMOVEFEATURE,
    /**
     * @param {VectorSourceEvent<Geometry>} evt The vector source event
     */
    function (evt) {
      if (!modifyingCollection) {
        modifyingCollection = true;
        collection.remove(evt.feature);
        modifyingCollection = false;
      }
    });
    collection.addEventListener(_CollectionEventType["default"].ADD,
    /**
     * @param {import("../Collection.js").CollectionEvent} evt The collection event
     */
    function (evt) {
      if (!modifyingCollection) {
        modifyingCollection = true;
        this.addFeature(
        /** @type {import("../Feature.js").default<Geometry>} */
        evt.element);
        modifyingCollection = false;
      }
    }.bind(this));
    collection.addEventListener(_CollectionEventType["default"].REMOVE,
    /**
     * @param {import("../Collection.js").CollectionEvent} evt The collection event
     */
    function (evt) {
      if (!modifyingCollection) {
        modifyingCollection = true;
        this.removeFeature(
        /** @type {import("../Feature.js").default<Geometry>} */
        evt.element);
        modifyingCollection = false;
      }
    }.bind(this));
    this.featuresCollection_ = collection;
  };
  /**
   * Remove all features from the source.
   * @param {boolean} [opt_fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature removefeature} events.
   * @api
   */


  VectorSource.prototype.clear = function (opt_fast) {
    if (opt_fast) {
      for (var featureId in this.featureChangeKeys_) {
        var keys = this.featureChangeKeys_[featureId];
        keys.forEach(_events.unlistenByKey);
      }

      if (!this.featuresCollection_) {
        this.featureChangeKeys_ = {};
        this.idIndex_ = {};
        this.uidIndex_ = {};
      }
    } else {
      if (this.featuresRtree_) {
        var removeAndIgnoreReturn = function (feature) {
          this.removeFeatureInternal(feature);
        }.bind(this);

        this.featuresRtree_.forEach(removeAndIgnoreReturn);

        for (var id in this.nullGeometryFeatures_) {
          this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
      }
    }

    if (this.featuresCollection_) {
      this.featuresCollection_.clear();
    }

    if (this.featuresRtree_) {
      this.featuresRtree_.clear();
    }

    this.nullGeometryFeatures_ = {};
    var clearEvent = new VectorSourceEvent(_VectorEventType["default"].CLEAR);
    this.dispatchEvent(clearEvent);
    this.changed();
  };
  /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */


  VectorSource.prototype.forEachFeature = function (callback) {
    if (this.featuresRtree_) {
      return this.featuresRtree_.forEach(callback);
    } else if (this.featuresCollection_) {
      this.featuresCollection_.forEach(callback);
    }
  };
  /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */


  VectorSource.prototype.forEachFeatureAtCoordinateDirect = function (coordinate, callback) {
    var extent = [coordinate[0], coordinate[1], coordinate[0], coordinate[1]];
    return this.forEachFeatureInExtent(extent, function (feature) {
      var geometry = feature.getGeometry();

      if (geometry.intersectsCoordinate(coordinate)) {
        return callback(feature);
      } else {
        return undefined;
      }
    });
  };
  /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */


  VectorSource.prototype.forEachFeatureInExtent = function (extent, callback) {
    if (this.featuresRtree_) {
      return this.featuresRtree_.forEachInExtent(extent, callback);
    } else if (this.featuresCollection_) {
      this.featuresCollection_.forEach(callback);
    }
  };
  /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */


  VectorSource.prototype.forEachFeatureIntersectingExtent = function (extent, callback) {
    return this.forEachFeatureInExtent(extent,
    /**
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @return {T|undefined} The return value from the last call to the callback.
     */
    function (feature) {
      var geometry = feature.getGeometry();

      if (geometry.intersectsExtent(extent)) {
        var result = callback(feature);

        if (result) {
          return result;
        }
      }
    });
  };
  /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with an {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<import("../Feature.js").default<Geometry>>|null} The collection of features.
   * @api
   */


  VectorSource.prototype.getFeaturesCollection = function () {
    return this.featuresCollection_;
  };
  /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<import("../Feature.js").default<Geometry>>} Features.
   * @api
   */


  VectorSource.prototype.getFeatures = function () {
    var features;

    if (this.featuresCollection_) {
      features = this.featuresCollection_.getArray().slice(0);
    } else if (this.featuresRtree_) {
      features = this.featuresRtree_.getAll();

      if (!(0, _obj.isEmpty)(this.nullGeometryFeatures_)) {
        (0, _array.extend)(features, (0, _obj.getValues)(this.nullGeometryFeatures_));
      }
    }

    return (
      /** @type {Array<import("../Feature.js").default<Geometry>>} */
      features
    );
  };
  /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<import("../Feature.js").default<Geometry>>} Features.
   * @api
   */


  VectorSource.prototype.getFeaturesAtCoordinate = function (coordinate) {
    var features = [];
    this.forEachFeatureAtCoordinateDirect(coordinate, function (feature) {
      features.push(feature);
    });
    return features;
  };
  /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<import("../Feature.js").default<Geometry>>} Features.
   * @api
   */


  VectorSource.prototype.getFeaturesInExtent = function (extent) {
    if (this.featuresRtree_) {
      return this.featuresRtree_.getInExtent(extent);
    } else if (this.featuresCollection_) {
      return this.featuresCollection_.getArray().slice(0);
    } else {
      return [];
    }
  };
  /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(import("../Feature.js").default<Geometry>):boolean} [opt_filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {import("../Feature.js").default<Geometry>} Closest feature.
   * @api
   */


  VectorSource.prototype.getClosestFeatureToCoordinate = function (coordinate, opt_filter) {
    // Find the closest feature using branch and bound.  We start searching an
    // infinite extent, and find the distance from the first feature found.  This
    // becomes the closest feature.  We then compute a smaller extent which any
    // closer feature must intersect.  We continue searching with this smaller
    // extent, trying to find a closer feature.  Every time we find a closer
    // feature, we update the extent being searched so that any even closer
    // feature must intersect it.  We continue until we run out of features.
    var x = coordinate[0];
    var y = coordinate[1];
    var closestFeature = null;
    var closestPoint = [NaN, NaN];
    var minSquaredDistance = Infinity;
    var extent = [-Infinity, -Infinity, Infinity, Infinity];
    var filter = opt_filter ? opt_filter : _functions.TRUE;
    this.featuresRtree_.forEachInExtent(extent,
    /**
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     */
    function (feature) {
      if (filter(feature)) {
        var geometry = feature.getGeometry();
        var previousMinSquaredDistance = minSquaredDistance;
        minSquaredDistance = geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);

        if (minSquaredDistance < previousMinSquaredDistance) {
          closestFeature = feature; // This is sneaky.  Reduce the extent that it is currently being
          // searched while the R-Tree traversal using this same extent object
          // is still in progress.  This is safe because the new extent is
          // strictly contained by the old extent.

          var minDistance = Math.sqrt(minSquaredDistance);
          extent[0] = x - minDistance;
          extent[1] = y - minDistance;
          extent[2] = x + minDistance;
          extent[3] = y + minDistance;
        }
      }
    });
    return closestFeature;
  };
  /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [opt_extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */


  VectorSource.prototype.getExtent = function (opt_extent) {
    return this.featuresRtree_.getExtent(opt_extent);
  };
  /**
   * Get a feature by its identifier (the value returned by feature.getId()).
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {import("../Feature.js").default<Geometry>|null} The feature (or `null` if not found).
   * @api
   */


  VectorSource.prototype.getFeatureById = function (id) {
    var feature = this.idIndex_[id.toString()];
    return feature !== undefined ? feature : null;
  };
  /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {import("../Feature.js").default<Geometry>|null} The feature (or `null` if not found).
   */


  VectorSource.prototype.getFeatureByUid = function (uid) {
    var feature = this.uidIndex_[uid];
    return feature !== undefined ? feature : null;
  };
  /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default|undefined} The feature format.
   * @api
   */


  VectorSource.prototype.getFormat = function () {
    return this.format_;
  };
  /**
   * @return {boolean} The source can have overlapping geometries.
   */


  VectorSource.prototype.getOverlaps = function () {
    return this.overlaps_;
  };
  /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */


  VectorSource.prototype.getUrl = function () {
    return this.url_;
  };
  /**
   * @param {Event} event Event.
   * @private
   */


  VectorSource.prototype.handleFeatureChange_ = function (event) {
    var feature =
    /** @type {import("../Feature.js").default<Geometry>} */
    event.target;
    var featureKey = (0, _util.getUid)(feature);
    var geometry = feature.getGeometry();

    if (!geometry) {
      if (!(featureKey in this.nullGeometryFeatures_)) {
        if (this.featuresRtree_) {
          this.featuresRtree_.remove(feature);
        }

        this.nullGeometryFeatures_[featureKey] = feature;
      }
    } else {
      var extent = geometry.getExtent();

      if (featureKey in this.nullGeometryFeatures_) {
        delete this.nullGeometryFeatures_[featureKey];

        if (this.featuresRtree_) {
          this.featuresRtree_.insert(extent, feature);
        }
      } else {
        if (this.featuresRtree_) {
          this.featuresRtree_.update(extent, feature);
        }
      }
    }

    var id = feature.getId();

    if (id !== undefined) {
      var sid = id.toString();

      if (this.idIndex_[sid] !== feature) {
        this.removeFromIdIndex_(feature);
        this.idIndex_[sid] = feature;
      }
    } else {
      this.removeFromIdIndex_(feature);
      this.uidIndex_[featureKey] = feature;
    }

    this.changed();
    this.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].CHANGEFEATURE, feature));
  };
  /**
   * Returns true if the feature is contained within the source.
   * @param {import("../Feature.js").default<Geometry>} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */


  VectorSource.prototype.hasFeature = function (feature) {
    var id = feature.getId();

    if (id !== undefined) {
      return id in this.idIndex_;
    } else {
      return (0, _util.getUid)(feature) in this.uidIndex_;
    }
  };
  /**
   * @return {boolean} Is empty.
   */


  VectorSource.prototype.isEmpty = function () {
    if (this.featuresRtree_) {
      return this.featuresRtree_.isEmpty() && (0, _obj.isEmpty)(this.nullGeometryFeatures_);
    }

    if (this.featuresCollection_) {
      return this.featuresCollection_.getLength() === 0;
    }

    return true;
  };
  /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */


  VectorSource.prototype.loadFeatures = function (extent, resolution, projection) {
    var loadedExtentsRtree = this.loadedExtentsRtree_;
    var extentsToLoad = this.strategy_(extent, resolution, projection);

    var _loop_1 = function _loop_1(i, ii) {
      var extentToLoad = extentsToLoad[i];
      var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad,
      /**
       * @param {{extent: import("../extent.js").Extent}} object Object.
       * @return {boolean} Contains.
       */
      function (object) {
        return (0, _extent.containsExtent)(object.extent, extentToLoad);
      });

      if (!alreadyLoaded) {
        ++this_1.loadingExtentsCount_;
        this_1.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].FEATURESLOADSTART));
        this_1.loader_.call(this_1, extentToLoad, resolution, projection, function (features) {
          --this.loadingExtentsCount_;
          this.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].FEATURESLOADEND, undefined, features));
        }.bind(this_1), function () {
          --this.loadingExtentsCount_;
          this.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].FEATURESLOADERROR));
        }.bind(this_1));
        loadedExtentsRtree.insert(extentToLoad, {
          extent: extentToLoad.slice()
        });
      }
    };

    var this_1 = this;

    for (var i = 0, ii = extentsToLoad.length; i < ii; ++i) {
      _loop_1(i, ii);
    }

    this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
  };

  VectorSource.prototype.refresh = function () {
    this.clear(true);
    this.loadedExtentsRtree_.clear();

    _super.prototype.refresh.call(this);
  };
  /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */


  VectorSource.prototype.removeLoadedExtent = function (extent) {
    var loadedExtentsRtree = this.loadedExtentsRtree_;
    var obj;
    loadedExtentsRtree.forEachInExtent(extent, function (object) {
      if ((0, _extent.equals)(object.extent, extent)) {
        obj = object;
        return true;
      }
    });

    if (obj) {
      loadedExtentsRtree.remove(obj);
    }
  };
  /**
   * Remove a single feature from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {import("../Feature.js").default<Geometry>} feature Feature to remove.
   * @api
   */


  VectorSource.prototype.removeFeature = function (feature) {
    if (!feature) {
      return;
    }

    var featureKey = (0, _util.getUid)(feature);

    if (featureKey in this.nullGeometryFeatures_) {
      delete this.nullGeometryFeatures_[featureKey];
    } else {
      if (this.featuresRtree_) {
        this.featuresRtree_.remove(feature);
      }
    }

    var result = this.removeFeatureInternal(feature);

    if (result) {
      this.changed();
    }
  };
  /**
   * Remove feature without firing a `change` event.
   * @param {import("../Feature.js").default<Geometry>} feature Feature.
   * @return {import("../Feature.js").default<Geometry>|undefined} The removed feature
   *     (or undefined if the feature was not found).
   * @protected
   */


  VectorSource.prototype.removeFeatureInternal = function (feature) {
    var featureKey = (0, _util.getUid)(feature);
    var featureChangeKeys = this.featureChangeKeys_[featureKey];

    if (!featureChangeKeys) {
      return;
    }

    featureChangeKeys.forEach(_events.unlistenByKey);
    delete this.featureChangeKeys_[featureKey];
    var id = feature.getId();

    if (id !== undefined) {
      delete this.idIndex_[id.toString()];
    }

    delete this.uidIndex_[featureKey];
    this.dispatchEvent(new VectorSourceEvent(_VectorEventType["default"].REMOVEFEATURE, feature));
    return feature;
  };
  /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {import("../Feature.js").default<Geometry>} feature The feature.
   * @return {boolean} Removed the feature from the index.
   * @private
   */


  VectorSource.prototype.removeFromIdIndex_ = function (feature) {
    var removed = false;

    for (var id in this.idIndex_) {
      if (this.idIndex_[id] === feature) {
        delete this.idIndex_[id];
        removed = true;
        break;
      }
    }

    return removed;
  };
  /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */


  VectorSource.prototype.setLoader = function (loader) {
    this.loader_ = loader;
  };
  /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */


  VectorSource.prototype.setUrl = function (url) {
    (0, _asserts.assert)(this.format_, 7); // `format` must be set when `url` is set

    this.url_ = url;
    this.setLoader((0, _featureloader.xhr)(url, this.format_));
  };

  return VectorSource;
}(_Source["default"]);

var _default = VectorSource;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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